import { useSelector } from 'react-redux';

const useEnv = (variableName) => {
	const { environmentVariables, isLoading } = useSelector(state => state.configuration);

	if (isLoading) return null;

	return environmentVariables[variableName] ?? null;
};

export default useEnv;
